// extracted by mini-css-extract-plugin
export default {"corporateActions":"styles_corporateActions__PyuzB"};